import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import UserSidebar from './UserSidebar'

export default function BuyerProfile(props) {
    let [user, setUser] = useState({})
    let navigate = useNavigate()

    useEffect(() => {
        (async () => {
            let response = await fetch("/api/user/" + localStorage.getItem("userid"), {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    "authorization": localStorage.getItem("token")
                }
            })
            response = await response.json()
            if (response.result === "Done")
                setUser(response.data)
            else
                navigate('/login')
        })()
    }, [])

    return (
        props.title ?
            <>
                <div className={`${props.title === "OrderDetail" ? "" : "container mt-4"}`}>
                    <div className="testimonial-item img-border-radius shadow-sm bg-white p-3">
                        <h5>Delivery Address {props.title === "OrderDetail" ? "" : <span className='float-end fs-6 border py-1 px-2 border-info rounded'><Link to='/update-profile'>Change</Link></span>}</h5>
                        <span><b>{user.name}</b>, {user.address}, {user.city}, {user.state}-<b>{user.pin}</b>, (+91) {user.phone}</span>
                    </div>
                </div>
            </> :
            <div className="container mt-4">
                <div className='row'>
                    <div className="col-md-3">
                        <UserSidebar />
                    </div>
                    <div className="col-md-9">
                        <div className="testimonial-item img-border-radius shadow-sm bg-white p-4">
                            <h3 className='border-bottom border-2 mb-4'>Information</h3>
                            <div className="row">
                                <div className="col-md-6 col-sm-12 mb-2">
                                    <strong>Name</strong>
                                    <p>{user.name}</p>

                                </div>
                                <div className="col-md-6 col-sm-12 mb-2">
                                    <strong>User Name</strong>
                                    <p>{user.username}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-sm-12 mb-2">
                                    <strong>Email</strong>
                                    <p>{user.email}</p>
                                </div>
                                <div className="col-md-6 col-sm-12 mb-2">
                                    <strong>Phone</strong>
                                    <p>{user.phone}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <strong>Address</strong>
                                    <p>{user.address}</p>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <strong>Pin</strong>
                                    <p>{user.pin}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <strong>City</strong>
                                    <p>{user.city}</p>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <strong>State</strong>
                                    <p>{user.state}</p>
                                </div>
                            </div>
                            <div>
                                <Link to='/update-profile' className='btn bg-info text-dark w-100'>Update Profile</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}
